// Polyfill Buffer for browser when dependencies expect Node's Buffer
import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

// Set Buffer after all imports to satisfy import/first lint rule
// @ts-ignore
if (
  typeof window !== "undefined" &&
  typeof (window as any).Buffer === "undefined"
) {
  // @ts-ignore
  (window as any).Buffer = Buffer;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
